<template>
  <div class="audio-controller">
    <img :src="src" @click="onClick" />

    <audio id="foreground" volume="1.0" autoplay />
    <audio id="background" volume="0.6" autoplay />
  </div>
</template>

<script>
export default {
  name: "AudioController",
  data() {
    return {
      muted: true
    };
  },
  computed: {
    src: function() {
      return this.muted
        ? "/images/game/audio-off.png"
        : "/images/game/audio-on.png";
    }
  },
  methods: {
    onClick() {
      this.muted = !this.muted;

      const foreAudio = document.getElementById("foreground");
      const backAudio = document.getElementById("background");

      foreAudio.muted = this.muted;
      backAudio.muted = this.muted;
    },
    playFore(src, loop) {
      if (this.muted) {
        return;
      }
      const audio = document.getElementById("foreground");

      audio.src = src;
      if (loop) {
        audio.loop = true;
      } else {
        audio.loop = false;
      }
    },
    playBack(src, loop) {
      if (this.muted) {
        return;
      }
      const audio = document.getElementById("background");

      audio.src = src;
      if (loop) {
        audio.loop = true;
      } else {
        audio.loop = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.audio-controller {
  img {
    width: 28px;
    height: 28px;
  }
}
</style>